import { render, staticRenderFns } from "./questions-page.vue?vue&type=template&id=129936af&"
import script from "./questions-page.vue?vue&type=script&lang=ts&"
export * from "./questions-page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wamp\\www\\Pentacom\\baumit.com\\vue-project\\calculator-common\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('129936af')) {
      api.createRecord('129936af', component.options)
    } else {
      api.reload('129936af', component.options)
    }
    module.hot.accept("./questions-page.vue?vue&type=template&id=129936af&", function () {
      api.rerender('129936af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/questions-page/questions-page.vue"
export default component.exports